package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_06_02_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While investigating the stables, Falorn finds some treasure inside a hastily-made demon nest. Goram, Tuesday, Annette, and Dirk investigate the eastern hallway from which several of the demons emerged. They find empty bunkbeds and Malusian guardsmen corpses leaning against the walls and corners of the room. The guardsmen have only been dead a day or two.  Our heroes still hear the sound of running water and the smell of fresh air, although they haven’t see any aqueduct or natural river nor have they seen any access points linking the tunnel to the surface. Goram and Caper stay behind to give funeral rites to the dead guards. To the south, our heroes find a heavy locked door.  Annette attempts to pick the lock but gives up, fearing that she might break her thieves tools.  Goram returns to the group with a key ring he found on one of the guards and opens the door.  The party investigates the tunnel further but only finds a dead end. The group travels north, finding a door that opens out into the Darkway which has curved to the east. In a nook near the door, our heroes find more treasure.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes collect their treasure. Coin: 92g 80g 140p 180p 1250g ——— 4622g = (evenly distributed) 660g * 7 + 2g")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Art: 50g copper challis ??? Gold bracelet 275 carved bone jaguar 1000g ivory statue of a bird (sparrow or starling)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Magical Items: Wings of flying -> Caper 2x scroll cases")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Alter self")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Confusion Greatsword of sharpness (bonus to critical strikes) -> Bigs")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes are surprised to find all this treasure. Goram agrees that it is abnormal for a guard outpost to have valuable art or such a large amount of gold and platinum.  The heroes exchange theories of corrupt guards, organized crime, and innocent banking systems, but there doesn’t seem to be any evidence to clarify any of these theories.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes depart, continuing deeper into the Darkway with Bigs keeping watch.  Before long, 5 guards on horseback appear behind our heroes and overtake them, flagging them down.  Our heroes pull over slowly and ask Goram to speak to the guards.")
    }
}
